module.exports = __webpack_public_path__ + "static/assets/07d1ab9bdd31c3f8fb68656a992d0826.svg";